import { formatInTimeZone, toZonedTime } from "date-fns-tz";

const TIME_ZONE = "America/Sao_Paulo";

export function formatDateForAPI(date: Date): string {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

function getUtcDateByTime(timeUtc: string): Date {
  const [hStr, mStr = "0", sStr = "0"] = timeUtc.split(":");
  const hours = Number(hStr);
  const minutes = Number(mStr);
  const seconds = Number(sStr);

  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const day = now.getUTCDate();

  return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
}

function getLocalDateByTime(timeUtc: string): Date {
  const [hStr, mStr = "0", sStr = "0"] = timeUtc.split(":");
  const hours = Number(hStr);
  const minutes = Number(mStr);
  const seconds = Number(sStr);

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  return new Date(year, month, day, hours, minutes, seconds);
}

export function formatTimeUtcToDateLocal(timeUtc?: string): Date {
  if (!timeUtc) return null;

  const utcDate = getUtcDateByTime(timeUtc);
  const zonedDate = toZonedTime(utcDate, TIME_ZONE);

  return zonedDate;
}

export function formatTimeUtcToTimeLocal(
  timeUtc?: string,
  fallback: string = null
): string {
  if (!timeUtc) return fallback;

  const utcDate = getUtcDateByTime(timeUtc);
  const zonedTime = formatInTimeZone(utcDate, TIME_ZONE, "HH:mm");

  return zonedTime;
}

export function formatDateLocalToTimeUtc(
  dateLocal?: Date,
  fallback: string = null
): string {
  if (!dateLocal) return fallback;

  const hh = String(dateLocal.getHours()).padStart(2, "0");
  const mm = String(dateLocal.getMinutes()).padStart(2, "0");
  const dateTimeZone = getLocalDateByTime(`${hh}:${mm}:00`);

  const timeUtc = formatInTimeZone(dateTimeZone, "UTC", "HH:mm");
  return timeUtc;
}

export function formatDateUTCToTimeLocal(
  dateUtc?: string,
  fallback: string = null
): string {
  if (!dateUtc) return fallback;

  return formatInTimeZone(dateUtc, TIME_ZONE, "HH:mm");
}

export function isLate(dateUtc?: string): boolean {
  if (!dateUtc) return false;
  return new Date(dateUtc) < new Date();
}

export function isDateOlderThanLastMonth(targetDate: Date): boolean {
  const today = new Date();

  const startOfLastMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );
  startOfLastMonth.setHours(0, 0, 0, 0);

  const date = new Date(targetDate);
  date.setHours(0, 0, 0, 0);

  return date < startOfLastMonth;
}

export function isDateAfterTodayOrBeforeJuneOfLastYear(
  targetDate: Date
): boolean {
  const today = new Date();
  const juneMonthIndex = 5;
  const startOfJuneOfLastYear = new Date(
    today.getFullYear() - 1,
    juneMonthIndex,
    1
  );
  startOfJuneOfLastYear.setHours(0, 0, 0, 0);

  const date = new Date(targetDate);
  date.setHours(0, 0, 0, 0);

  return date < startOfJuneOfLastYear || date > today;
}
